module.exports = __webpack_public_path__ + "static/media/thrive_data.c3763c77.csv";